import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'

export const Route = createFileRoute('/auth')({
  beforeLoad: async () => {
    const { isAuthenticated } = useAuthStore.getState()

    // If user is already authenticated, redirect to dashboard
    if (isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: () => <Outlet />,
})
